import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { isEmptyString } from '@helpers';
import {
  Gebied
} from '@models/gebied.model';
import { ApiServiceAbstract } from '@api-services/api.service.abstract';
// import { MachtigingsRelatie } from '@app/models/machtigings-relatie.model';

/**********
 ** NB als er maar 1 call is voor een bepaald data-type: zet die call dan in resource service
 **    als er meerdere calls zijn voor hetzelfde type: maak dan een eigen service
 **********/

export interface EphytoCertificaatZoekparameters {
  certificaatNummer: string;
  landVanAfgifte: string;
  datumVanAfgifte: Date;
}

export interface LogResult {
  type: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class ResourceApiService extends ApiServiceAbstract {

  public getLanden(): Observable<Gebied[]> {
    return this.httpWrapper.get('/' + this.contextRoot + '/getLanden');
  }

  public getGebieden(sedID: string): Observable<Gebied[]> {
    if (isEmptyString(sedID)) {
      return of([]);
    }
    return this.httpWrapper.post('/' + this.contextRoot + '/getGebieden', { sedID });
  }

  public getEphytoCertificaten(zoekparameters: EphytoCertificaatZoekparameters): Observable<Blob> {
    return this.httpWrapper.post('/' + this.contextRoot+ '/getEphytoCertificaten', zoekparameters, { responseType: 'text' });
  }

}
